import React from 'react'
import ArticleCoverAndHeader from '../../GuidePages/ArticleComponents/ArticleCoverAndHeader'
import styles from '../../GuidePages/ArticleComponents/Common.module.css'
import Row from '../../GuidePages/ArticleComponents/Row'

function MentalHealthPage() {

    const refList ={
        heading: "Links to mental health care resources",
        linkList: [
          {linkTitle:"List of resources on instagram",link:"https://www.instagram.com/weareyuvaa/guide/mental-health-care-resources/17912011159731216/?igshid=15y2siydqiatv"},
      ]
      }

    return (
            <ArticleCoverAndHeader readTime={4}
            title="Mental Health, Why Is It Important?"
            author="Anuhya Sai"
            authorLink="https://www.instagram.com/__anuhya._/?hl=en">

            <div className={styles.introPara}>
                <p>
                WHO (World Health Organization) defines good health as psychological,
physiological and social well-being. These three aspects influence each other.
The following article emphasizes on mental health. Being mentally healthy is to
feel safe both physically and emotionally. Often this aspect is neglected due to
various reasons like, society’s stigma of not accepting mental health issues.
Bagging up all the emotions and not reaching out for help is a serious thing.
Mental health problems start from unnoticeable yet small things that we don’t
give attention to. People never feel ashamed to reach out when they are physically
ill, they are even ready to load their body with tons of medicines. Most of the
commonly reported mental health conditions are anxiety and depression. Nearly
3/4th of the people doesn’t even know that they have issues mentally that have to
be dealt with. Seeking out for help is the first step. Often therapy is not advised
or considered, which is the biggest mistake. Psychotherapy is a way to help
people with a broad variety of mental illnesses and emotional difficulties. It can
help eliminate or control troubling symptoms, so a person can feel better and lead
a stable life. Psychologists just help us to walk on the right track and teach us how
to tackle things. Considering the current pandemic situation, everyone, especially
people who are not able to resume back to their life, feel like they are stuck in a
loop. Many thoughts hit our brain in such situations. Reaching out, expressing
what you feel, talking to someone whom you feel safe with is really important
right now. No matter how many mental health quotes or articles you come across,
all you have to do is believe and keep telling yourself that, “this is not forever,
this too shall pass”. Ignoring the fact that you are constantly sad and carrying all
the emotional load doesn’t mean you are strong. But, learning how to cope with
them and maintaining a balance between these emotions makes you stronger. It’s
never too late to acknowledge the fact that you need help and you have to start
looking out for red flags. Keep your pace, you don’t have to rush anything. Many
of you might feel sad for not giving your best performance in these times, trust
us, there are far more worse things that are happening right now. Hang in there
and keep believing in yourself. Put your mental health as your first priority. If
you are someone who is trying to support people, we are so proud of you. If you
want to reach out to affordable mental health resources, there’s a link provided
down below. We, members of VITrendz, wish you loads of love, laughter and
health. Hoping that you all are staying safe and precautious.
                
                </p>
            </div>

            <Row row={refList} links/>
      </ArticleCoverAndHeader>
    )
}

export default MentalHealthPage
